// Single source of truth for the backend's base URL. Every action/hook that
// talks to the API imports these instead of hardcoding 'http://localhost:8000'
// — set via docker-compose so the app can point at a different host (e.g.
// the nginx-fronted local-api.swipeeit.com) with no code changes.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'
export const WS_BASE_URL = process.env.REACT_APP_WS_URL || API_BASE_URL.replace(/^http/, 'ws')
